import React, { useEffect, useState } from "react";
import axios from "axios";
import socket from "../../socket"; // Import WebSocket connection
import { endpoints } from "../../services/operations/api"; 
import "./RealTimeAttendees.css"; 

const RealTimeAttendees = () => {
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);

  useEffect(() => {

    const fetchEvents = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token")); 

        const response = await axios.get(endpoints.GET_ALL_EVENTS_API, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.success) {
          const events = response.data.events;
          const now = new Date();

        
          const upcoming = events.filter((event) => new Date(event.date) > now);
          const past = events.filter((event) => new Date(event.date) <= now);

          setUpcomingEvents(upcoming);
          setPastEvents(past);
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();

  
    socket.on("attendeeCountUpdated", ({ eventId, attendeeCount }) => {
      setUpcomingEvents((prevEvents) =>
        prevEvents.map((event) =>
          event._id === eventId ? { ...event, attendeeCount } : event
        )
      );

      setPastEvents((prevEvents) =>
        prevEvents.map((event) =>
          event._id === eventId ? { ...event, attendeeCount } : event
        )
      );
    });

    return () => {
      socket.off("attendeeCountUpdated");
    };
  }, []);

  return (
    <div className="realtime-container">
      <h1 className="realtime-title">Event List</h1>


      <div className="events-section-unique">
        <h2 className="events-heading-unique">Upcoming Events</h2>
        {upcomingEvents.length > 0 ? (
          <table className="event-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Date</th>
                <th>Attendees</th>
              </tr>
            </thead>
            <tbody>
              {upcomingEvents.map((event) => (
                <tr key={event._id}>
                  <td>{event.name}</td>
                  <td>{event.description}</td>
                  <td>{new Date(event.date).toLocaleDateString()}</td>
                  <td>{event.attendeeCount} / {event.maxAttendees}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-events">No upcoming events available.</p>
        )}
      </div>


      <div className="events-section-unique">
        <h2 className="events-heading-unique">Past Events</h2>
        {pastEvents.length > 0 ? (
          <table className="event-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Date</th>
                <th>Attendees</th>
              </tr>
            </thead>
            <tbody>
              {pastEvents.map((event) => (
                <tr key={event._id}>
                  <td>{event.name}</td>
                  <td>{event.description}</td>
                  <td>{new Date(event.date).toLocaleDateString()}</td>
                  <td>{event.attendeeCount} / {event.maxAttendees}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-events">No past events available.</p>
        )}
      </div>
    </div>
  );
};

export default RealTimeAttendees;
